
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./docs-tools.json") })
        }
      }, "path---docs-tools");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---docs-tools!./.cache/json/docs-tools.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---docs-tools!./.cache/json/docs-tools.json
// module chunks = 15178676390636814000